import React from 'react';
import { createRoot } from 'react-dom/client';

import { loadPayPalSDK, loadStripeSDK } from '../../common/utils';
import { Router } from './components';
import configureMoment from './configureMoment';

const renderApp = (ModuleRoot) => {
  // elements of the app shell:
  const mainNode = document.getElementById('ticket-purchase');

  createRoot(mainNode).render(ModuleRoot);
};

const renderModule = (ModuleRoot) => {
  if (document.readyState !== 'complete') {
    document.addEventListener(
      'DOMContentLoaded',
      () => renderApp(ModuleRoot),
      false
    );
  } else {
    renderApp(ModuleRoot);
  }
};

const config = window.resmioApp.config['src/config'];

const { facility } = config;

configureMoment(config);

if (facility.stripe_publish_key) {
  loadStripeSDK();
}

if (facility.paypal_client_id) {
  loadPayPalSDK({
    clientId: facility.paypal_client_id,
    currency: facility.currency,
  });
}

renderModule(<Router />);
